module.exports = __webpack_public_path__ + "img/reward-coin.adc17c86.png";